import React from "react";
import {useGlobalContext} from "../../context.";
import Book from "../BookList/Book";
import Loading from "../Loader/Loader";
import coverImg from "../../images/cover_not_found.jpg";
import "./BookList.css";
import Footer from "../Footer/Footer";
import {Link} from "react-router-dom";

//https://covers.openlibrary.org/b/id/240727-S.jpg

const BookList = () => {
  const {books, loading, resultTitle} = useGlobalContext();
  const booksWithCovers = books.map((singleBook) => {
    return {
      ...singleBook,
      // removing /works/ to get only id
      id: singleBook.id.replace("/works/", ""),
      cover_img: singleBook.cover_id ? `https://covers.openlibrary.org/b/id/${singleBook.cover_id}-L.jpg` : coverImg,
    };
  });

  if (loading) return <Loading />;

  return (
    <section className='booklist'>
      <div className='recommendation-list'>
        <Link to={`/recommendation/fiction`}>
          <span>fiction</span>
        </Link>
        <Link to={`/recommendation/romance`}>
          <span>romance</span>
        </Link>
        <Link to={`/recommendation/self-improvement`}>
          <span>self improvement</span>
        </Link>
        <Link to={`/recommendation/science`}>
          <span>science</span>
        </Link>
      </div>
      <div className='container'>
        <div className='section-title'>
          <h2>{resultTitle}</h2>
        </div>
        <div className='booklist-content grid'>
          {booksWithCovers.slice(0, 30).map((item, index) => {
            return <Book key={index} {...item} />;
          })}
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default BookList;
